import { render, staticRenderFns } from "./CollectPlatformRecord.vue?vue&type=template&id=6f2e9603&scoped=true&"
import script from "./CollectPlatformRecord.vue?vue&type=script&lang=js&"
export * from "./CollectPlatformRecord.vue?vue&type=script&lang=js&"
import style0 from "./CollectPlatformRecord.vue?vue&type=style&index=0&id=6f2e9603&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2e9603",
  null
  
)

export default component.exports